import { createContext } from 'use-context-selector';
import { AccessDbContextType } from './accessDb';

export const defaultAccessDbValues: AccessDbContextType = {
  data: undefined,
  fileName: undefined,
};

export const AccessDbContext = createContext<AccessDbContextType>(defaultAccessDbValues);
